import { createFormAction } from 'redux-form-saga'
export const AREA_FORM_KEY = 'AREA_FORM_KEY'
export const AreaFormAction = createFormAction(AREA_FORM_KEY)